"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countdown = exports.at = exports.newsUrl = undefined;

var _util = require("../../util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// After a release: clear the releaseNewsUrl, bump months up by one.
// release at midnight UTC. 8 EST, 5 PST
var newsUrl = exports.newsUrl = "";
var at = exports.at = Util.Timestamp.UTC(2099, "nov", 1);
var countdown = exports.countdown = {
  startsAt: Util.Timestamp.UTC(2099, "oct", 24),
  endsAt: Util.Timestamp.UTC(2099, "nov", 1)
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvZmxhZ3MvcmVsZWFzZS5qcyJdLCJuYW1lcyI6WyJVdGlsIiwibmV3c1VybCIsImF0IiwiVGltZXN0YW1wIiwiVVRDIiwiY291bnRkb3duIiwic3RhcnRzQXQiLCJlbmRzQXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7SUFBWUEsSTs7OztBQUVaO0FBQ0E7QUFDTyxJQUFNQyw0QkFBVSxFQUFoQjtBQUNBLElBQU1DLGtCQUFLRixLQUFLRyxTQUFMLENBQWVDLEdBQWYsQ0FBbUIsSUFBbkIsRUFBeUIsS0FBekIsRUFBZ0MsQ0FBaEMsQ0FBWDtBQUNBLElBQU1DLGdDQUFZO0FBQ3ZCQyxZQUFVTixLQUFLRyxTQUFMLENBQWVDLEdBQWYsQ0FBbUIsSUFBbkIsRUFBeUIsS0FBekIsRUFBZ0MsRUFBaEMsQ0FEYTtBQUV2QkcsVUFBUVAsS0FBS0csU0FBTCxDQUFlQyxHQUFmLENBQW1CLElBQW5CLEVBQXlCLEtBQXpCLEVBQWdDLENBQWhDO0FBRmUsQ0FBbEIiLCJmaWxlIjoicmVsZWFzZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgKiBhcyBVdGlsIGZyb20gXCIuLi8uLi91dGlsXCJcblxuLy8gQWZ0ZXIgYSByZWxlYXNlOiBjbGVhciB0aGUgcmVsZWFzZU5ld3NVcmwsIGJ1bXAgbW9udGhzIHVwIGJ5IG9uZS5cbi8vIHJlbGVhc2UgYXQgbWlkbmlnaHQgVVRDLiA4IEVTVCwgNSBQU1RcbmV4cG9ydCBjb25zdCBuZXdzVXJsID0gXCJcIlxuZXhwb3J0IGNvbnN0IGF0ID0gVXRpbC5UaW1lc3RhbXAuVVRDKDIwOTksIFwibm92XCIsIDEpXG5leHBvcnQgY29uc3QgY291bnRkb3duID0ge1xuICBzdGFydHNBdDogVXRpbC5UaW1lc3RhbXAuVVRDKDIwOTksIFwib2N0XCIsIDI0KSxcbiAgZW5kc0F0OiBVdGlsLlRpbWVzdGFtcC5VVEMoMjA5OSwgXCJub3ZcIiwgMSksXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/flags/release.js
// module id = 366
// module chunks = 0